import { swRequest } from "@sourcewhale/core";

export const removeContact = (body) =>
  swRequest({
    path: "/api/extension/remove_contact",
    method: "POST",
    body,
  });

export const getCompanyInsights = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/extension/company_insights",
      method: "POST",
      body,
    },
    opts,
  );

export const downvoteCompanyInsights = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/extension/downvote_insights",
      method: "POST",
      body,
    },
    opts,
  );
